import React from "react";

/**
 * Optygo brand mark.
 *
 * - variant="icon"       → square "go" tile (used in avatars / mobile / chat bubbles)
 * - variant="wordmark"   → full "Optygo" wordmark (Opty white + go green)
 *
 * Sized so it composes well next to short Hebrew text. Strokes/fills come
 * straight from the brand guide (#00E5FF green, #09090B navy).
 */
export function PulseLogo({ size = 28, variant = "icon", className = "" }) {
  if (variant === "wordmark") {
    // Compact wordmark — renders nicely in a sidebar header
    return (
      <div
        className={`inline-flex items-baseline tracking-tight ${className}`}
        style={{ fontSize: size, lineHeight: 1, fontFamily: "'IBM Plex Sans Hebrew', system-ui, sans-serif", fontWeight: 700, letterSpacing: "-0.02em" }}
        aria-label="Optygo"
        data-testid="optygo-wordmark"
      >
        <span style={{ color: "#FAFAFA" }}>Opty</span>
        <span style={{ color: "#00E5FF" }}>go</span>
      </div>
    );
  }

  // Icon — "go" inside a rounded navy square, mirrors the official app icon
  const radius = Math.max(4, Math.round(size * 0.22));
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Optygo"
      data-testid="optygo-icon"
    >
      <rect x="0" y="0" width="40" height="40" rx={radius} fill="#09090B" />
      <text
        x="20"
        y="28"
        textAnchor="middle"
        fontSize="20"
        fontWeight="800"
        fill="#00E5FF"
        fontFamily="'IBM Plex Sans Hebrew', system-ui, sans-serif"
        style={{ letterSpacing: "-0.05em" }}
      >
        go
      </text>
    </svg>
  );
}

export default PulseLogo;
